import { createSlice, createAction } from "@reduxjs/toolkit";

const SESSION_END_TIME_KEY = "sessionEndTime";

function getStoredTimeLeft() {
    const endTime = localStorage.getItem(SESSION_END_TIME_KEY);
    if (!endTime) return 0;
    const remaining = Math.floor((Number(endTime) - Date.now()) / 1000);
    return remaining > 0 ? remaining : 0;
}

const initialState = {
    sessionTimeLeft: getStoredTimeLeft(),
    sessionTimedOut: false,
}

export const sessionTimingSlice = createSlice({
    name: "sessionTiming",
    initialState,
    reducers: {
        setSessionTime(state, action) {
            const seconds = action.payload;
            const endTime = Date.now() + seconds * 1000;
            localStorage.setItem(SESSION_END_TIME_KEY, String(endTime));
            state.sessionTimeLeft = seconds;
            state.sessionTimedOut = false;
        },
        decreaseSessionTime(state) {
            const endTime = localStorage.getItem(SESSION_END_TIME_KEY);
            if (endTime) {
                const remaining = Math.floor((Number(endTime) - Date.now()) / 1000);
                state.sessionTimeLeft = remaining > 0 ? remaining : 0;
            } else if (state.sessionTimeLeft > 0) {
                state.sessionTimeLeft -= 1;
            }
        },
        setSessionTimedOut(state) {
            state.sessionTimedOut = true;
            localStorage.removeItem(SESSION_END_TIME_KEY);
        },
        clearSessionTime(state) {
            state.sessionTimeLeft = 0;
            state.sessionTimedOut = false;
            localStorage.removeItem(SESSION_END_TIME_KEY);
        }
    }
});

export const sessionTimingAction = {
    startSessionTimer: createAction("sessionTiming/startSessionTimer"),
    setSessionTime: sessionTimingSlice.actions.setSessionTime,
    decreaseSessionTime: sessionTimingSlice.actions.decreaseSessionTime,
    setSessionTimedOut: sessionTimingSlice.actions.setSessionTimedOut,
    clearSessionTime: sessionTimingSlice.actions.clearSessionTime,
};

export const getSessionTimeLeft = (state) => state.sessionTiming.sessionTimeLeft;
export const getSessionTimedOut = (state) => state.sessionTiming.sessionTimedOut;

export default sessionTimingSlice.reducer
